import {zodResolver} from "@hookform/resolvers/zod";
import {Field} from "@mytour/ui/form";
import type {UseFormReturn} from "react-hook-form";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {v4 as uuid} from "uuid";
import {z} from "zod";
import type {Step3ShiftingPriceForm} from "../Step3ShiftingPrice";
import {ZoneLine} from "./ZoneLine";

export const zoneNumberSchema = z.object({
  zoneNumber: z.number(),
});
export type zoneNumberForm = z.infer<typeof zoneNumberSchema>;

type Props = {
  hookForm: UseFormReturn<Step3ShiftingPriceForm>;
  disabled: boolean;
};

export function ZoneSetup({hookForm, disabled}: Props) {
  const {watch, setValue} = hookForm;
  const zones = watch("zones");
  const {t: translate} = useTranslation();
  const formZone = useForm<zoneNumberForm>({
    resolver: zodResolver(zoneNumberSchema),
    defaultValues: {zoneNumber: zones.length},
  });
  return (
    <>
      <div>
        <Field
          name="zoneNumber"
          type="number"
          step="1"
          min="2"
          max="8"
          label={translate("myTourApp.platformUser.shiftingZoneNumber")}
          onChange={(e) => onShiftingZoneNumberChange(Number.parseInt(e.target.value, 10))}
          hookForm={formZone}
          disabled={disabled}
        />
        {zones?.map((aZone, index) => (
          <ZoneLine key={aZone.id} index={index} hookForm={hookForm} disabled={disabled} />
        ))}
      </div>
    </>
  );

  function onShiftingZoneNumberChange(num: number) {
    if (num && num >= 2 && num <= 8) {
      let newZones = [...zones];
      if (num > newZones.length) {
        for (let i = newZones.length - 1; i < num; i++) {
          const head2 = newZones[i - 2];
          const head1 = newZones[i - 1];
          const head2Distance = head2?.distance ?? 0;
          const head1Distance = head1?.distance ?? 0;
          const distance =
            i === num - 1 ? undefined : head1Distance + Math.max(5, head1Distance - head2Distance);
          if (i < newZones.length) {
            const current = newZones[i];
            if (current) {
              current.distance = distance;
            }
          } else {
            const label = `Zone ${i + 1}`;
            const head2Amount = head2?.amount ?? 0;
            const head1Amount = head1?.amount ?? 0;
            const amount = head1Amount + Math.max(5, head1Amount - head2Amount);
            newZones.push({id: uuid(), label, distance, amount});
          }
        }
      } else if (num < newZones.length) {
        newZones = newZones.slice(0, num);
      }
      const last = newZones[newZones.length - 1];
      if (last) {
        last.distance = undefined;
      }
      setValue("zones", newZones);
    }
  }
}
